export const COMPANY = {
  name: 'MRK Digital Consultancy',
  address: { tr: '[Şirket adresi]', en: '[Company address]' },
  email: 'hello@mrkdigitalco.com',
  website: 'mrkdigitalco.com',
};

export const LAST_UPDATED = { tr: 'Haziran 2026', en: 'June 2026' };
